export const appColors = {
  black: "#000000",
  white: "#ffffff",
  gray: "#bababa",
  textDecription: "#949494",
  textDarkGreen: "#334155",
  doneText: "#28c76f",
  doneBackground: "#dcf6e8",
  successText: "#00bad0",
  purpleText: "#7366ef",
  primary: "rgb(11,83,148)",
  backgroundColorMain: "#F5F7FB",
  secondary: "rgb(255, 255, 255)",
  lightBlue: "rgb(0, 145, 194)",
  error: "rgb(255, 61, 61)",
  errorBackground: "#ffe2e3",
  blueText: "#0000CD",
  blueBackground: "#002fa7",
  warning: "#ffc800",
};
